import React from 'react';

export const Disclaimer = () => (
  <footer>
    <h3>Disclaimer</h3>
    <p>
      Gjør dette på eget ansvar og følg bruksanvisningen som følger med ditt
      gulv.
    </p>
    <p>
      Hvis du har tilbakemeldinger eller ønsker om mer funksjonallitet, kan du
      sende meg en{' '}
      <a
        rel="noopener"
        href="mailto:haakonwinther@gmail.com?subject=Parkettlegger.no"
      >
        epost
      </a>
      .
    </p>
  </footer>
);
